

class JoinOperatorQueryBuilder {

    protected _joinOperator: any[][] = [];
    protected _uniqueParameterID: string;
    protected _parameters: { [name: string]: any } = {};

    constructor() {
        this._uniqueParameterID = Array.from(new Array(10), (_) => String.fromCharCode(Math.round(Math.random() * 25) + 65)).join('')
    }

    public getParameters() {
        return this._parameters
    }

    public getJoinOperator() {
        return this._joinOperator
    }

    protected joinOperatorFactory(column: string, operator: string, needle: any, statement: 'AND' | 'OR'): this {

        const id = `${this._uniqueParameterID}${Object.keys(this._parameters).length + 1}`

        const needleIsColumn = /^[a-zA-Z\_]{1,100}\.[a-zA-Z\_]{1,100}$/.test(needle)

        this._joinOperator.push([`${column} ${operator} ${needleIsColumn ? needle : `:${id}`}`, statement])

        if(needleIsColumn === false) {
            
            this._parameters[id] = needle
        }
        
        return this
    }

    public on(column: string, operator: any, needle?: any): this {

        return needle ? (
            this.joinOperatorFactory(column, operator, needle, 'AND')
        ) : (
            this.joinOperatorFactory(column, '=', operator, 'AND')
        )
    }

    public orOn(column: string, operator: any, needle?: any): this {

        return needle ? (
            this.joinOperatorFactory(column, operator, needle, 'OR')
        ) : (
            this.joinOperatorFactory(column, '=', operator, 'OR')
        )
    }
}

export default JoinOperatorQueryBuilder